import { useQuery } from "@tanstack/react-query";
import { QA_API_DOMAIN, fetchWithSupabaseAuth } from "@/api/classifier";

export interface RawBundleFileContent {
  type: "pdf" | "png" | "jpeg" | "text" | "json";
  content: string;
  sidecarText?: string;
}

export function useBundleFile(bundleId: string, fileKey: string, enabled: boolean) {
  return useQuery({
    queryKey: ["raw-files-viewer-file", bundleId, fileKey],
    queryFn: async (): Promise<RawBundleFileContent> => {
      const res = await fetchWithSupabaseAuth(
        `${QA_API_DOMAIN}/raw-files-viewer/bundle/${bundleId}/file?key=${encodeURIComponent(fileKey)}`,
      );

      if (!res.ok) {
        const body = (await res.json().catch(() => ({}))) as { error?: string };
        throw new Error(body.error ?? `Failed to fetch file (${res.status})`);
      }

      return res.json() as Promise<RawBundleFileContent>;
    },
    enabled,
    staleTime: Infinity,
  });
}
